
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft11 as ObiWindShaft11Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-11.js';
 
 
 

 
 export const ObiWindShaft11 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-11',
   elementClass: ObiWindShaft11Element,
   events: {
     
   }
  });
 
 